<ng-container *ngIf="agChartOptions">
  <ag-charts-angular [options]="agChartOptions"></ag-charts-angular>
</ng-container>
